import { FC } from "react";
import userTranslationsHelper from "../../../../../languages/user-translations.helper";
import RailyOfficerListingItem from "../common/types/raily-officer-listing-item";
import RailyOfficerListingTableColumn from "../common/types/raily-officer-listing-table-column";
import RailyOfficerListingTableRow from "../common/types/raily-officer-listing-table-row";
import useRailyOfficerListingUserPermissions from "../common/user-permissions/use-raily-officer-listing-user-permissions";
import railyOfficerListingTableHelper from "./raily-officer-listing-table.helper";
import UserDeleteUserData from "../../../common/delete/common/types/user-delete-user-data";
import UserStatus from "../../../../../common/types/user-status";
import TableDeleteButtonComponent from "../../../../../common/components/table/button/delete/table-delete-button.component";
import TableComponent from "../../../../../common/components/table/table.component";

type RailyOfficerListingTableProps = {
  isError: boolean;
  isLoading: boolean;
  listingItems: RailyOfficerListingItem[];
  onSelectUserToDelete: (userData: UserDeleteUserData) => void;
};

const RailyOfficerListingTableComponent: FC<RailyOfficerListingTableProps> = (
  props
) => {
  const userPermissions = useRailyOfficerListingUserPermissions();

  const columns: RailyOfficerListingTableColumn[] =
    railyOfficerListingTableHelper.getColumns();

  const createTableRow = (
    listingItem: RailyOfficerListingItem
  ): RailyOfficerListingTableRow => {
    const translations =
      userTranslationsHelper.getRailyOfficerListingTranslations().table;

    const activityStatus = railyOfficerListingTableHelper.getStatusText(
      listingItem.status
    );

    const isDeleted = listingItem.status === UserStatus.DELETED;

    const isDeleteButtonVisible =
      !isDeleted && userPermissions.hasAccessToDeleteUser;

    return {
      id: listingItem.uuid,
      idForTesting: listingItem.uuid,
      value: {
        firstName: (
          <div title={listingItem.firstName}>{listingItem.firstName}</div>
        ),
        lastName: (
          <div title={listingItem.lastName}>{listingItem.lastName}</div>
        ),
        username: <div>{listingItem.username}</div>,
        phoneNumbers: (
          <div>
            {listingItem.phoneNumbers.map((phoneNumber, index) => (
              <div key={index} title={phoneNumber}>
                {phoneNumber}
              </div>
            ))}
          </div>
        ),
        email: <div title={listingItem.email}>{listingItem.email}</div>,
        status: <div title={activityStatus}>{activityStatus}</div>,
        actions: (
          <div className="d-flex" onClick={(event) => event.stopPropagation()}>
            {isDeleteButtonVisible && (
              <TableDeleteButtonComponent
                onClick={() =>
                  props.onSelectUserToDelete({
                    uuid: listingItem.uuid,
                    firstName: listingItem.firstName,
                    lastName: listingItem.lastName,
                  })
                }
                title={translations.userDeleteButtonTitle}
                idForTesting={`raily-officer-table-item-${listingItem.uuid}-delete-button`}
              />
            )}
          </div>
        ),
      },
    };
  };

  const rows: RailyOfficerListingTableRow[] = props.listingItems.map(
    (listingItem) => createTableRow(listingItem)
  );

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isError={props.isError}
      isLoading={props.isLoading}
    />
  );
};

export default RailyOfficerListingTableComponent;
